import React from "react";
import ItinerarySidebarBase from "./base";

interface ShowItinerarySidebarAppProps {
  showId: number
  artist: server.dto.ArtistSmall
  startDate: moment.Moment
  endDate: moment.Moment
  panelConfig: server.dto.ItinerarySidebarPanelConfig
  disableNewAppointments: boolean
  canLinkUnlinkTravel: boolean
}

export const ShowItinerarySidebarApp = (props: ShowItinerarySidebarAppProps) => {
  return <ItinerarySidebarBase
    item={{ type: "show", itemId: props.showId }}
    artist={props.artist}
    startDate={props.startDate}
    endDate={props.endDate}
    disableNewAppointments={props.disableNewAppointments}
    canLinkUnlinkTravel={props.canLinkUnlinkTravel}
    canLinkUnlinkShow={false}
    canAdd={props.panelConfig.canAdd}
    linkedItems={{
      flightSegmentIds: props.panelConfig.linkedFlightSegmentIds,
      groundTransportIds: props.panelConfig.linkedGroundTransportIds,
      trainSegmentIds: props.panelConfig.linkedTrainSegmentIds,
      showIds: [],
    }}
    onLinkUnlink={() => { }}
  />
}

interface GroundTransportSidebarAppProps {
  groundTransportId: number
  artist: server.dto.ArtistSmall
  startDate: moment.Moment
  endDate: moment.Moment

  linkedShowIds: number[]
  onLinkUnlinkShow: () => void
}

export const GroundTransportItinerarySidebarApp = (props: GroundTransportSidebarAppProps) => {
  return <ItinerarySidebarBase
    item={{ type: "groundTransport", itemId: props.groundTransportId }}
    artist={props.artist}
    startDate={props.startDate}
    endDate={props.endDate}
    disableNewAppointments={false}
    canLinkUnlinkTravel={false}
    canLinkUnlinkShow
    canAdd
    linkedItems={{
      flightSegmentIds: [],
      groundTransportIds: [],
      trainSegmentIds: [],
      showIds: props.linkedShowIds,
    }}
    onLinkUnlink={props.onLinkUnlinkShow}
  />
}